import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import './dark.css';
import { Translation } from 'react-i18next';
import { Row, Col, Form, Icon, message, Button } from 'antd';
import { apis } from '../api/index.js';
import i18n from 'i18next';
import echarts from 'echarts/lib/echarts';
// 引入柱状图
import 'echarts/lib/chart/bar';
// 引入折线图
import 'echarts/lib/chart/line';
// 引入饼图
import 'echarts/lib/chart/pie';
//引入图例组件
import 'echarts/lib/component/legend';
// 引入提示框和标题组件
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
// 引入中国地图
import 'echarts/map/js/china';
import geoJson from 'echarts/map/json/china.json';
import { geoCoordMap, ownProvienceData, provienceList, wsyList } from './geo'; //provienceData
import alertBg from '../imgs/dataDark/alert-bg.png';
import mapIcon from '../imgs/dataDark/map-icon.png';
// import CountUp from 'react-countup';
import { formatDate, getDay } from '../utils';
import loading from '../imgs/dataDark/loading1.gif';
import { allCity, allCityPy } from '../data/city.js';

//地图配置
var pos = { leftPlus: 85, leftCur: 0, left: 10, top: 10 };
// var line = [[0, 0], [8, 11], [0, 22]];
// var style = {
//   font: '12px "Microsoft YaHei", sans-serif',
//   textColor: '#8edbff',
//   lineColor: '#3270b5',
// };

let timer = 0;
class DataDarkForm extends Component {
  constructor(props) {
    super(props);
    const roleInfo = window.store.getState().api.user.info.operationAuths || '';
    const isAnonymity = roleInfo.indexOf('S') >= 0;
    this.state = {
      isAnonymity,
      sexStat: [],
      allStat: [],
      aiStat: [],
      userProducts: [],
      currentProduct: {},
      barData: {},
      mapData: [],
      mapAlertSetInterval: true,
      title: '',
      lineChartData: [],
      loading1: true,
      loading2: true,
      loading3: true,
      loading4: true,
      loading5: true,
      provinces: allCity,
      oldAiPositiveCnt: 0,
      oldDoctorPositiveCnt: 0,
      tagArr: [
        {
          id: '中国',
          textPY: 'ZHONGGUO',
          areaProvince: '',
          areaCity: '',
          areaDistrict: '',
        },
      ],
    };
  }

  static propTypes = {
    user: PropTypes.object,
    history: PropTypes.object,
  };

  componentDidMount() {
    this.getUserProducts(0);
    this.reSetBoardData();

    const _this = this;
    setInterval(function() {
      _this.setState({
        currentTime: formatDate(new Date()),
      });
    }, 1000);
  }

  getUserProducts = (index, value) => {
    const products = window.store.getState().api.user.info.products;
    const userProducts = [];
    products.map(item => {
      if (item.isAuth && item.productId === 11) userProducts.push(item);
      return item;
    });
    this.setState({
      userProducts,
      currentProduct: userProducts[index],
    });
    this.getBoardOtherData(userProducts[index], value);
    timer++;
  };

  reSetBoardData = () => {
    const _this = this;
    const resetTimer = setInterval(function() {
      if (!document.getElementById('increaseChart')) {
        clearInterval(resetTimer);
      } else {
        const { userProducts, searchValues } = _this.state;
        const index = timer % userProducts.length;
        _this.getUserProducts(index, searchValues);
        timer++;
      }
    }, 30 * 60 * 1000); //30分钟刷新一次
  };

  getBoardOtherData = (currentProduct, value, allCityCode) => {
    const fromTime = getDay(-30) + ' 0:0:0';
    const toTime = getDay(0) + ' 23:59:59';
    const post = {
      aiProductType: currentProduct.productId,
      fromTime,
      toTime,
      areaCountry: '',
    };
    if (value) post.areaProvince = value.area.split('-')[0];
    if (allCityCode) {
      post.areaProvince = allCityCode.areaProvince;
      post.areaCity = allCityCode.areaCity;
      post.areaDistrict = allCityCode.areaDistrict;
    }
    apis.boardOtherData(post).then(res => {
      if (res.code === '0') {
        let allStat5 = [],
          aiStat5 = [];
        for (let i in res.data.allStat) {
          if (i < 7) {
            let label = '',
              value = '';
            for (let j in res.data.allStat[i]) {
              label = j;
              value = res.data.allStat[i][j];
            }
            allStat5.push({ value, label });
          } else {
            break;
          }
        }
        for (let i in res.data.aiStat) {
          if (i < 7) {
            let label = '',
              value = '';
            for (let j in res.data.aiStat[i]) {
              label = j;
              value = res.data.aiStat[i][j];
            }
            aiStat5.push({ value, label });
          } else {
            break;
          }
        }
        this.setState({
          sexStat: res.data.sexStat,
          allStat: allStat5,
          aiStat: aiStat5,
          mapData: res.data.mapstat,
          title: i18n.t(currentProduct.productName),
          loading1: false,
          loading4: false,
          loading5: false,
          loading3: false,
        });
        this.setSexChart();
        this.setRankChart();
        this.setYangRankChart();
        const opt = {
          bgColor: 'rgba(0, 0, 0, 0)', // 画布背景色
          mapName: value && value.area ? value.area.split('-')[1] : '中国', // 地图名
          goDown: true, // 是否下钻
          mapData: geoJson,
          data: [],
          // 下钻回调
          callback: function(name, option, instance) {},
        };
        this.setState({
          lastOpt: opt,
        });
        if (allCityCode === undefined) {
          this.setMapCharts(opt);
        }
        this.getBoardXdaysData(currentProduct.productId, post);
        this.getBoardTodayData(currentProduct.productId, post);
      } else {
        message.error(res.message);
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };

  getBoardTodayData = (productId, data) => {
    const fromTime = getDay(0) + ' 0:0:0';
    const toTime = getDay(0) + ' 23:59:59';
    const post = {
      aiProductType: productId,
      fromTime,
      toTime,
      areaCountry: '',
    };
    if (data.areaProvince) post.areaProvince = data.areaProvince;
    if (data.areaCity) post.areaCity = data.areaCity;
    if (data.areaDistrict) post.areaDistrict = data.areaDistrict;
    const { isAnonymity } = this.state;
    apis.boardTodayData(post).then(res => {
      if (res.code === '0') {
        const data = res.data;
        if (isAnonymity) {
          const { oldAiPositiveCnt, oldDoctorPositiveCnt } = this.state;
          const aiCnt = data.aiCnt; //今日ai筛查数
          let aiPositiveCnt = data.aiPositiveCnt; //ai 阳性新增
          // aiPositiveCnt = oldAiPositiveCnt + 10;
          let doctorCnt = data.doctorCnt; //今日医生审核
          // let doctorPositiveCnt = data.doctorPositiveCnt; //今日医生审核肺结核阳性新增
          const num = 28;
          let doctorCntNew = aiCnt - num;
          let doctorPositiveCntNew = 0;
          if (oldAiPositiveCnt === 0) {
            for (let i = 0; i < aiPositiveCnt; i++) {
              const random = Math.random();
              if (random <= 0.6) doctorPositiveCntNew++;
            }
          } else {
            doctorPositiveCntNew = oldDoctorPositiveCnt;
            for (let i = oldAiPositiveCnt; i < aiPositiveCnt; i++) {
              const random = Math.random();
              if (random <= 0.6) doctorPositiveCntNew++;
            }
          }

          data.doctorPositiveCnt = doctorPositiveCntNew;
          if (doctorCntNew > 0 && doctorCntNew > doctorCnt)
            data.doctorCnt = doctorCntNew;

          this.setState({
            oldAiPositiveCnt: aiPositiveCnt,
            oldDoctorPositiveCnt: doctorPositiveCntNew,
          });
        }
        this.setState({ barData: res.data });
      } else {
        message.error(res.message);
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };

  getBoardXdaysData = (productId, data) => {
    const fromTime = getDay(-6) + ' 0:0:0';
    const toTime = getDay(0) + ' 23:59:59';
    const post = {
      aiProductType: productId,
      fromTime,
      toTime,
      areaCountry: '',
    };
    if (data.areaProvince) post.areaProvince = data.areaProvince;
    if (data.areaCity) post.areaCity = data.areaCity;
    if (data.areaDistrict) post.areaDistrict = data.areaDistrict;
    apis.boardXdaysData(post).then(res => {
      if (res.code === '0') {
        this.setState({
          lineChartData: res.data.dataMap || [],
          loading2: false,
        });
        this.setIncreaseChart();
      } else {
        message.error(res.message);
        if (res.code === '1009') this.props.history.push('/login');
      }
    });
  };
  sexData = () => {
    const { sexStat } = this.state;
    const data = [['product', i18n.t('male'), i18n.t('female')]];
    sexStat.forEach(item => {
      let f = 0,
        m = 0,
        name = '';
      for (let i in item) {
        name = i;
        f = item[i].F;
        m = item[i].M;
      }
      const current = [i18n.t(name), m, f];
      data.push(current);
    });
    return data;
  };

  setSexChart = () => {
    // 基于准备好的dom，初始化echarts实例
    if (!document.getElementById('sexChart')) return;
    var myChart = echarts.init(document.getElementById('sexChart'));
    // 绘制图表
    myChart.setOption({
      legend: {
        show: true,
        right: 10,
        top: 10,
        orient: 'horizontal',
        itemWidth: 11,
        itemHeight: 7,
        itemGap: 20,
        data: [
          {
            name: i18n.t('male'),
            icon: 'rect',
            textStyle: {
              fontSize: 12,
              color: 'rgba(255,255,255,0.45)',
            },
          },
          {
            name: i18n.t('female'),
            icon: 'rect',
            textStyle: {
              fontSize: 12,
              color: 'rgba(255,255,255,0.45)',
            },
          },
        ],
      },
      tooltip: {},
      dataset: { source: this.sexData() },
      xAxis: {
        type: 'category',
        axisLine: {
          lineStyle: { color: 'rgba(255,255,255,0.45)' },
        },
        axisLabel: {
          textStyle: {
            fontFamily: 'Microsoft YaHei',
            color: 'rgba(255,255,255,0.45)',
          },
        },
      },
      yAxis: {
        type: 'value',
        axisLine: {
          show: false,
        },
        splitLine: {
          show: true,
          lineStyle: { color: 'rgba(255,255,255,0.3)' },
        },
        axisLabel: {
          textStyle: {
            fontFamily: 'Microsoft YaHei',
            color: 'rgba(255,255,255,0.45)',
          },
        },
      },
      series: [
        {
          type: 'bar',
          barWidth: 11,
          name: i18n.t('male'),
          itemStyle: { color: '#5B8FF9' },
          barGap: '30%',
        },
        {
          type: 'bar',
          barWidth: 11,
          name: i18n.t('female'),
          itemStyle: { color: '#EC7846' },
          barGap: '30%',
        },
      ],
    });
  };

  setAiCntData = () => {
    const { lineChartData } = this.state;
    const allData = [],
      positiveData = [];
    lineChartData.forEach(line => {
      for (let i in line) {
        allData.push(line[i].aiAllCnt);
        positiveData.push(line[i].aiPositiveCnt);
      }
    });
    return { allData, positiveData };
  };

  setIncreaseChart = () => {
    const xData = [];
    for (let i = -6; i <= 0; i++) {
      xData.push(getDay(i, 'YMD'));
    }
    if (!document.getElementById('increaseChart')) return;
    var myChart = echarts.init(document.getElementById('increaseChart'));
    myChart.setOption({
      legend: {
        data: ['传片患者', '阳性患者'],
        textStyle: { fontSize: 12, color: 'rgb(255,255,255,0.6)' },
        right: 10,
        orient: 'vertical',
      },
      xAxis: {
        type: 'category',
        data: xData,
        axisLabel: {
          textStyle: { color: 'rgba(255, 255, 255, 0.45)' },
        },
        axisLine: {
          lineStyle: { color: 'rgb(0,253,255,0)' },
        },
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          textStyle: { color: 'rgba(255, 255, 255, 0.45)' },
        },
        splitLine: {
          lineStyle: { color: 'rgb(255,255,255,0.3)' },
        },
        axisLine: {
          lineStyle: { color: 'rgb(0,253,255,0)' },
        },
      },
      series: [
        {
          name: '传片患者',
          data: this.setAiCntData().allData,
          type: 'line',
          itemStyle: { color: '#648CE7' },
        },
        {
          name: '阳性患者',
          data: this.setAiCntData().positiveData,
          type: 'line',
          itemStyle: { color: '#CB6C49' },
        },
      ],
    });
  };

  setRankChart = () => {
    const COLOR = ['#5B8FF9', '#5AD8A6'];
    if (!document.getElementById('rankChart')) return;
    var myChart = echarts.init(document.getElementById('rankChart'));
    const data = [];
    for (let i = this.state.allStat.length - 1; i >= 0; i--) {
      data.push(this.state.allStat[i]);
    }
    const { isAnonymity } = this.state;
    myChart.setOption({
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
      },
      grid: {
        top: 10,
        left: '3%',
        right: 40,
        bottom: 0,
        containLabel: true,
      },
      xAxis: { type: 'value', show: false },
      yAxis: {
        show: true,
        // inverse: true,
        type: 'category',
        axisLine: { show: false },
      },
      series: [
        {
          name: 'label',
          type: 'bar',
          barWidth: 15,
          label: {
            show: true,
            position: 'insideLeft',
            color: 'rgba(255,255,255,0.45)',
            fontSize: 12,
          },
          data: data.map(item => {
            return {
              value: 0,
              label: {
                formatter() {
                  return isAnonymity ? '***卫生院' : item.label;
                },
              },
            };
          }),
        },
        {
          name: 'value',
          type: 'bar',
          barWidth: 15,
          label: {
            show: true,
            position: 'right',
            fontSize: 12,
            offset: [5, 0],
            formatter({ value }) {
              return `${value}`;
            },
          },
          data: data.map(({ value }, index) => {
            let color = COLOR[index % COLOR.length];
            return {
              value,
              label: { color: '#ffffff' },
              itemStyle: { color },
            };
          }),
        },
      ],
    });
  };

  setYangRankChart = () => {
    const COLOR = ['#FA7373', '#73A0FA'];
    if (!document.getElementById('yangRankChart')) return;
    var myChart = echarts.init(document.getElementById('yangRankChart'));
    const data = [];
    for (let i = this.state.aiStat.length - 1; i >= 0; i--) {
      data.push(this.state.aiStat[i]);
    }
    const { isAnonymity } = this.state;
    myChart.setOption({
      tooltip: {
        trigger: 'axis',
        axisPointer: { type: 'shadow' },
      },
      grid: {
        top: 10,
        left: '3%',
        right: 40,
        bottom: 0,
        containLabel: true,
      },
      xAxis: { type: 'value', show: false },
      yAxis: {
        show: true,
        // inverse: true,
        type: 'category',
        axisLine: { show: false },
      },
      series: [
        {
          name: 'label',
          type: 'bar',
          barWidth: 15,
          label: {
            show: true,
            position: 'insideLeft',
            color: 'rgba(255,255,255,0.45)',
            fontSize: 12,
          },
          data: data.map(item => {
            return {
              value: 0,
              label: {
                formatter() {
                  return isAnonymity ? '***卫生院' : item.label;
                },
              },
            };
          }),
        },
        {
          name: 'value',
          type: 'bar',
          barWidth: 15,
          label: {
            show: true,
            position: 'right',
            fontSize: 12,
            offset: [5, 0],
            formatter({ value }) {
              return `${value}`;
            },
          },
          data: data.map(({ value }, index) => {
            let color = COLOR[index % COLOR.length];
            return {
              value,
              label: { color: '#ffffff' },
              itemStyle: { color },
            };
          }),
        },
      ],
    });
  };

  convertData = data => {
    var res = [];
    for (var i = 0; i < data.length; i++) {
      let name = data[i].areaName;
      name = name.substring(0, name.length - 1);
      var geoCoord = geoCoordMap[name];
      if (geoCoord) {
        res.push(geoCoord.concat(data[i].areaName).concat(data[i].dicomCount));
      }
    }
    return res;
  };
  convertData2 = data => {
    var res = [];
    if (wsyList[data]) {
      for (var name in wsyList[data]) {
        var geoCoord = wsyList[data][name];
        if (geoCoord) {
          res.push({ name: name, value: geoCoord });
        }
      }
    }
    return res;
  };
  convertData3 = (data, city) => {
    var res = [];
    if (wsyList[city]) {
      for (var name in wsyList[city]) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].areaName === name) {
            var geoCoord = wsyList[city][name];
            if (geoCoord) {
              res.push(geoCoord.concat(name).concat(data[i].dicomCount));
            }
          }
        }
      }
    }
    return res;
  };
  setMapOption = (opt, myChart) => {
    var mapIcons = { bg: alertBg, icon: mapIcon };
    const { mapData } = this.state;
    let convertMapData = this.convertData(mapData);

    for (let i = 0; i < ownProvienceData.length; i++) {
      let flag = true;
      convertMapData.forEach(item => {
        let name = item[2];
        name = name.substring(0, name.length - 1);
        if (name === ownProvienceData[i].name) {
          flag = false;
          ownProvienceData[i].value = item[3] + 100;
        }
      });
      if (flag) {
        ownProvienceData[i].value = 100;
      }
    }

    var option = {
      backgroundColor: opt.bgColor,
      animation: true,
      progressiveThreshold: 3,
      graphic: [],
      grid: {},
      geo: {
        map: opt.mapName,
        //"center": [0, 12],
        aspectScale: 0.8,
        roam: true,
        scaleLimit: { min: 1.2, max: 15 },
        zoom: 1.2,
        label: {
          //标签样式设置
          normal: {
            show: true,
            color: '#FFFFFF',
            verticalAlign: 'bottom',
          },
          emphasis: {
            //鼠标移上去的样式
            show: false,
            color: '#FFFFFF',
          },
        },
        itemStyle: {
          normal: {
            borderColor: 'rgba(147, 235, 248, 1)',
            borderWidth: 1,
            areaColor: {
              type: 'radial',
              x: 0.5,
              y: 0.5,
              r: 0.8,
              colorStops: [
                {
                  offset: 0,
                  color: 'rgba(147, 235, 248, 0)', // 0% 处的颜色
                },
                {
                  offset: 1,
                  color: 'rgba(147, 235, 248, .5)', // 100% 处的颜色
                },
              ],
              globalCoord: false, // 缺省为 false
            },
            shadowColor: 'rgba(128, 217, 248, 1)',
            shadowOffsetX: -5,
            shadowOffsetY: 12,
            shadowBlur: 10,
          },
          emphasis: { areaColor: '#389BB7', borderWidth: 0 },
        },
      },
      series: [
        {
          type: 'effectScatter',
          coordinateSystem: 'geo',
          z: 99,
          zlevel: 99,
          // data: [],
          symbolSize: 14,
          label: {
            normal: {
              show: true,
              formatter: function(params) {
                const value2 = params.data.value[2];
                const value3 = params.data.value[3];
                return `{iconVal|}  {div|${value2}}\n{fontVal|传片数              ${value3}\nAI筛查数           ${value3}}`;
              },
              color: '#FFFFFF',
              verticalAlign: 'top',
              position: 'bottom',
              padding: [10, 20],
              lineHeight: 25,
              backgroundColor: { image: mapIcons.bg },
              rich: {
                iconVal: {
                  width: 12,
                  height: 14,
                  backgroundColor: { image: mapIcons.icon },
                },
                fontVal: {
                  height: 15,
                  fontSize: 16,
                  color: '#ffffff',
                },
                div: { fontSize: 16, color: '#ffffff' },
              },
            },
            emphasis: {
              show: true,
            },
          },
          // itemStyle: {
          //   color: '#00c7ff',
          // },
          showEffectOn: 'render',
          rippleEffect: {
            period: 15,
            scale: 4,
            brushType: 'fill',
          },
          hoverAnimation: true,
          itemStyle: {
            normal: { color: '#89BDE6' },
          },
          data: ownProvienceData,
        },
        {
          type: 'map',
          mapType: 'china',
          geoIndex: 0,
          label: {
            normal: { show: true },
            emphasis: { show: true },
          },
          data: ownProvienceData,
        },
        {
          type: 'effectScatter',
          coordinateSystem: 'geo',
          // data: ownProvienceDot,
          showEffectOn: 'emphasis',
          z: 1,
          rippleEffect: { brushType: 'stroke' },
          hoverAnimation: true,
          label: {
            normal: {
              formatter: '{b}',
              position: 'right',
              show: true,
              color: '#ffffff',
            },
          },
          itemStyle: {
            normal: {
              color: '#ffffff',
              shadowBlur: 10,
              shadowColor: '#ffffff',
            },
          },
          zlevel: 1,
        },
      ],
      // visualMap: {
      //   min: 0,
      //   max: 11,
      //   left: 'left',
      //   top: 'bottom',
      //   text: ['高', '低'],
      //   calculable: true,
      //   seriesIndex: '1',
      //   show: false,
      //   inRange: {
      //     color: ['#89BDE6', '#2185C7'],
      //   },
      // },
    };

    return option;
  };

  setMapCharts = opt => {
    echarts.registerMap(opt.mapName, geoJson);
    if (!document.getElementById('mapChart')) return;
    this.myChart = echarts.init(document.getElementById('mapChart'));

    var defaultOpt = {
      mapName: 'china', // 地图展示
      goDown: false, // 是否下钻
      bgColor: 'rgba(0,0,0,0)', // 画布背景色
      activeArea: [], // 区域高亮,同echarts配置项
      data: [],
      // 下钻回调(点击的地图名、实例对象option、实例对象)
      callback: function(name, option, instance) {},
    };

    if (opt) opt = echarts.util.extend(defaultOpt, opt);

    this.setState({ name: [opt.mapName], idx: 0 });

    let option = this.setMapOption(opt, this.myChart);

    this.myChart.clear();
    this.myChart.setOption(option);
    var cityToPinyin = allCityPy;

    let _this = this;
    this.myChart.off('click');
    this.myChart.on('click', function(params) {
      let filterarr = [];
      let name = params.name;
      let _self = this;
      if (name) {
        if (
          _this.state.provinces[name] &&
          _this.state.provinces[name].features.length === 1
        ) {
          _this.clickMapChart(name, _self, this.myChart, opt, option, name);
        } else {
          _this.clickMapChart(name, _self, this.myChart, opt, option);
        }

        let flag = provienceList.some(item => item.name === name);
        if (flag) {
          let areaProvinces = 0;
          provienceList.map(item => {
            if (item.name === name) {
              const values = { area: item.value + '-' + item.name };
              areaProvinces = item.value;
              _this.setState({
                name: ['中国'],
                loading1: true,
                loading2: true,
                loading3: true,
                loading4: true,
                loading5: true,
                searchValues: values,
                currentCity: name,
              });
              _this.getBoardOtherData(_this.state.currentProduct, values);
            }
            return item;
          });
          if (cityToPinyin[name]) {
            let textPY = cityToPinyin[name]
              ? cityToPinyin[name].toUpperCase()
              : '';
            filterarr.push({
              id: name,
              textPY: textPY,
              areaProvince: areaProvinces,
              areaCity: '',
              areaDistrict: '',
            });
            _this.setState({
              tagArr: _this.ss([..._this.state.tagArr, ...filterarr]),
            });
          }
        } else if (
          _this.state.provinces[name] &&
          _this.state.provinces[name].features.length > 1
        ) {
          const cityName = _this.state.provinces[name];
          if (cityName) {
            _this.setState({
              name: ['中国'],
              loading1: true,
              loading2: true,
              loading3: true,
              loading4: true,
              loading5: true,
              searchValues: null,
              currentCity: name,
            });
            _this.getBoardOtherData(_this.state.currentProduct, false, {
              areaProvince: cityName.features[0].properties.acroutes[1],
              areaCity: cityName.features[0].properties.acroutes[2],
              areaDistrict:
                cityName.features.length === 1
                  ? cityName.features[0].properties.adcode
                  : '',
            });
          }
          if (cityToPinyin[name]) {
            let textPY = cityToPinyin[name]
              ? cityToPinyin[name].toUpperCase()
              : '';
            filterarr.push({
              id: name,
              textPY: textPY,
              areaProvince: cityName.features[0].properties.acroutes[1],
              areaCity: cityName.features[0].properties.acroutes[2],
              areaDistrict:
                cityName.features.length === 1
                  ? cityName.features[0].properties.adcode
                  : '',
            });
            _this.setState({
              tagArr: _this.ss([..._this.state.tagArr, ...filterarr]),
            });
          }
        } else if (_this.state.provinces[name]) {
          const cityName = _this.state.provinces[name];
          _this.setState({
            name: ['中国'],
            loading1: true,
            loading2: true,
            loading3: true,
            loading4: true,
            loading5: true,
            searchValues: null,
            currentCity: name,
          });
          _this.getBoardOtherData(_this.state.currentProduct, false, {
            areaProvince: cityName.features[0].properties.acroutes[1],
            areaCity: cityName.features[0].properties.acroutes[2],
            areaDistrict:
              cityName.features.length === 1
                ? cityName.features[0].properties.adcode
                : '',
          });

          if (cityToPinyin[name]) {
            let textPY = cityToPinyin[name]
              ? cityToPinyin[name].toUpperCase()
              : '';
            filterarr.push({
              id: name,
              textPY: textPY,
              areaProvince: cityName.features[0].properties.acroutes[1],
              areaCity: cityName.features[0].properties.acroutes[2],
              areaDistrict:
                cityName.features.length === 1
                  ? cityName.features[0].properties.adcode
                  : '',
            });
            _this.setState({
              tagArr: _this.ss([..._this.state.tagArr, ...filterarr]),
            });
          }
        }
      }
    });
    this.intervalFn(option, _this);
  };
  intervalFn = (option, _this) => {
    if (!document.getElementById('mapChart')) return;
    let cityIndex = 0;
    this.setState({ mapAlertSetInterval: false });
    if (this.mapTimer) {
      clearInterval(this.mapTimer);
    }
    this.mapTimer = setInterval(function() {
      let arr = _this.state.tagArr;

      option.series[0].data = [];
      const { mapData } = _this.state;
      let newmapData = [];
      if (
        arr[arr.length - 1].areaProvince === '' &&
        arr[arr.length - 1].areaCity === '' &&
        arr[arr.length - 1].areaDistrict === ''
      ) {
        mapData.forEach(item => {
          if (item.id !== 0 && item.pid === 0) {
            newmapData.push(item);
          }
        });
      } else if (
        arr[arr.length - 1].areaProvince !== '' &&
        arr[arr.length - 1].areaCity === '' &&
        arr[arr.length - 1].areaDistrict === ''
      ) {
        mapData.forEach(item => {
          if (
            item.id !== 0 &&
            item.pid !== 0 &&
            item.pid === arr[arr.length - 1].areaProvince
          ) {
            newmapData.push(item);
          }
        });
      } else if (
        arr[arr.length - 1].areaProvince !== '' &&
        arr[arr.length - 1].areaCity !== '' &&
        arr[arr.length - 1].areaDistrict === ''
      ) {
        mapData.forEach(item => {
          if (item.id !== 0 && item.pid === arr[arr.length - 1].areaCity) {
            newmapData.push(item);
          }
        });
      } else if (
        arr[arr.length - 1].areaProvince !== '' &&
        arr[arr.length - 1].areaCity !== '' &&
        arr[arr.length - 1].areaDistrict !== ''
      ) {
        mapData.forEach(item => {
          if (item.pid === arr[arr.length - 1].areaDistrict) {
            newmapData.push(item);
          }
        });
      }
      // debugger
      let convertMapData = _this.convertData(newmapData);
      if (convertMapData.length === 0) {
        let cityName = '';
        mapData.map(a => {
          newmapData.map(b => {
            if (a.id === b.pid) {
              cityName = a.areaName;
            }
            return null;
          });
          return null;
        });
        convertMapData = _this.convertData3(newmapData, cityName);
      }
      cityIndex = cityIndex % convertMapData.length;
      var coordCity = Object.keys(convertMapData)[cityIndex];

      var coord = convertMapData[coordCity];
      option = echarts
        .getInstanceByDom(document.getElementById('mapChart'))
        .getOption();
      option.series[0].data = [{ city: coordCity, value: coord }];
      cityIndex++;

      echarts
        .getInstanceByDom(document.getElementById('mapChart'))
        .setOption(option);
    }, 2500);
  };
  zoomAnimation = myChart => {
    var count = null;
    var zoom = function(per) {
      if (!count) count = per;
      count = count + per;
      myChart.setOption({ geo: { zoom: count } });
      if (count < 1)
        window.requestAnimationFrame(function() {
          zoom(0.2);
        });
    };
    window.requestAnimationFrame(function() {
      zoom(0.2);
    });
  };

  initSeriesData = data => {
    var temp = [];
    for (var i = 0; i < data.length; i++) {
      var geoCoord = geoCoordMap[data[i].name];
      if (geoCoord) {
        temp.push({
          name: data[i].name,
          value: geoCoord.concat(data[i].value, data[i].level),
        });
      }
    }
    return temp;
  };
  resetOption = (i, o, n, opt, loadwsy) => {
    let { name, idx, mapData } = this.state;
    let convertMapData = this.convertData(mapData);

    ownProvienceData.forEach(data => {
      let flag = true;
      convertMapData.forEach(item => {
        let name = item[2];
        name = name.substring(0, name.length - 1);
        if (name === data.name) {
          flag = false;
          data.value = item[3] + 100;
        }
        if (flag) data.value = 100;
      });
    });
    var mapIcons = {
      bg: alertBg,
      icon: mapIcon,
    };
    // if (n === '中国') {
    if (o && o.geo) {
      o.geo.label = {
        //标签样式设置
        normal: { show: true, color: '#FFFFFF', verticalAlign: 'bottom' },
        //鼠标移上去的样式
        emphasis: { show: false, color: '#FFFFFF' },
      };
    }

    o.series = [
      {
        type: 'effectScatter',
        coordinateSystem: 'geo',
        z: 99,
        zlevel: 99,
        // data: [],
        symbolSize: 14,
        label: {
          normal: {
            show: true,
            formatter: function(params) {
              const value2 = params.data.value[2];
              const value3 = params.data.value[3];
              return `{iconVal|}  {div|${value2}}\n{fontVal|传片数              ${value3}\nAI筛查数           ${value3}}`;
            },
            color: '#FFFFFF',
            verticalAlign: 'top',
            position: 'bottom',
            padding: [10, 20],
            lineHeight: 32,
            backgroundColor: { image: mapIcons.bg },
            rich: {
              iconVal: {
                width: 12,
                height: 14,
                backgroundColor: { image: mapIcons.icon },
              },
              fontVal: {
                height: 15,
                fontSize: 16,
                color: '#ffffff',
              },
              div: { fontSize: 16, color: '#ffffff' },
            },
          },
          emphasis: { show: true },
        },
        showEffectOn: 'render',
        rippleEffect: { period: 15, scale: 4, brushType: 'fill' },
        hoverAnimation: true,
        itemStyle: { normal: { color: '#89BDE6' } },
        data: ownProvienceData,
      },
      {
        type: 'effectScatter',
        coordinateSystem: 'geo',
        showEffectOn: 'render',
        rippleEffect: { period: 15, scale: 4, brushType: 'fill' },
        hoverAnimation: true,
        itemStyle: { normal: { color: '#89BDE6' } },
        data: ownProvienceData,
      },
      {
        type: 'map',
        mapType: 'china',
        geoIndex: 0,
        label: {
          normal: { show: true },
          emphasis: { show: true },
        },
        data: ownProvienceData,
      },
    ];
    if (loadwsy) {
      o.series.push({
        name: '城市',
        type: 'scatter',
        coordinateSystem: 'geo',
        data: this.convertData2(loadwsy),
        symbolSize: function(val) {
          return 5;
        },
        label: {
          normal: {
            formatter: '{b}',
            position: 'right',
            show: true,
          },
          emphasis: { show: true },
        },
        itemStyle: {
          normal: { color: '#9ff5ff' },
        },
        animation: false,
      });
    }

    var j = name.indexOf(n);
    var l = o.graphic.length;
    if (j < 0) {
      if (o.graphic.length > 2) {
        for (var x = 0; x < opt.data.length; x++) {
          if (n === opt.data[x].name + '市') {
            o.series[0].data = this.initSeriesData([opt.data[x]]);
            break;
          } else o.series[0].data = [];
        }
      }
      name.push(n);
      idx++;
    } else {
      o.series[0].data = this.initSeriesData(opt.data);
      name.splice(j + 1, l);
      idx = j;
      pos.leftCur -= pos.leftPlus * (l - j - 1);
    }

    o.geo.map = n;
    o.geo.zoom = 0.4;
    i.clear();

    i.setOption(o);
    this.zoomAnimation(i);
    opt.callback(n, o, i);
    this.setState({ name, idx });
  };
  ss = arr => {
    var result = [];
    var obj = {};
    for (var i = 0; i < arr.length; i++) {
      if (!obj[arr[i].id]) {
        result.push(arr[i]);
        obj[arr[i].id] = true;
      }
    }
    return result;
  };
  loadMap = (_self, name, option, myChart, opt, loadwsy) => {
    const { provinces } = this.state;
    if (name) {
      const data = JSON.stringify(provinces[name]);
      if (data) {
        echarts.registerMap(name, data);
        this.resetOption(_self, option, name, opt, loadwsy);
        this.myChart.clear();
        this.myChart.setOption(option);
        let _this = this;
        this.intervalFn(option, _this);
      }
    }
  };

  clickMapChart = (name, _self, myChart, opt, option, loadwsy) => {
    let { mapData } = this.state;
    let convertMapData = this.convertData(mapData);
    ownProvienceData.forEach(data => {
      let flag = true;
      convertMapData.forEach(item => {
        if (item.name === data.name) {
          flag = false;
          data.value = item.value + 100;
        }
      });
      if (flag) data.value = 100;
    });
    let newOption = option;
    newOption.geo.label = {
      //标签样式设置
      normal: { show: true, color: '#FFFFFF', verticalAlign: 'bottom' },
      //鼠标移上去的样式
      emphasis: { show: true, color: '#FFFFFF' },
    };
    newOption.series = [
      {
        type: 'effectScatter',
        coordinateSystem: 'geo',
        showEffectOn: 'render',
        rippleEffect: { period: 15, scale: 4, brushType: 'fill' },
        hoverAnimation: true,
        itemStyle: { normal: { color: '#89BDE6' } },
        data: ownProvienceData,
      },
      {
        type: 'map',
        mapType: 'china',
        geoIndex: 0,
        label: {
          normal: { show: true },
          emphasis: { show: true },
        },
        data: ownProvienceData,
      },
    ];
    if (loadwsy) {
      newOption.series.push({
        name: '城市',
        type: 'scatter',
        coordinateSystem: 'geo',
        data: this.convertData2(loadwsy),
        symbolSize: function(val) {
          return 5;
        },
        label: {
          normal: { formatter: '{b}', position: 'right', show: true },
          emphasis: { show: true },
        },
        itemStyle: {
          normal: { color: '#9ff5ff', shadowBlur: 10, shadowColor: '#b7cfd2' },
        },
      });
    }
    this.loadMap(_self, name, newOption, myChart, opt, loadwsy);
  };
  handleExit = () => {
    window.close();
  };
  changeMap = data => {
    if (!document.getElementById('mapChart')) return;
    const opt = {
      bgColor: 'rgba(0, 0, 0, 0)', // 画布背景色
      mapName: data.id, // 地图名
      goDown: true, // 是否下钻
      mapData: geoJson,
      data: [],
      // 下钻回调
      callback: function(name, option, instance) {},
      series: [],
    };

    let option = this.setMapOption(
      opt,
      echarts.getInstanceByDom(document.getElementById('mapChart'))
    );

    if (
      data.areaCity !== '' &&
      data.areaDistrict !== '' &&
      data.areaProvince !== ''
    ) {
      option.series.push({
        name: '城市',
        type: 'scatter',
        coordinateSystem: 'geo',
        data: this.convertData2(data.id),
        symbolSize: function(val) {
          return 5;
        },
        label: {
          normal: {
            formatter: '{b}',
            position: 'right',
            show: true,
          },
          emphasis: {
            show: true,
          },
        },
        itemStyle: {
          normal: {
            color: '#9ff5ff',
          },
        },
        animation: false,
      });
    }
    echarts.getInstanceByDom(document.getElementById('mapChart')).clear();
    echarts
      .getInstanceByDom(document.getElementById('mapChart'))
      .setOption(option);

    if (data.areaCity === '' && data.areaDistrict === '') {
      this.setState({
        name: ['中国'],
        loading1: true,
        loading2: true,
        loading3: true,
        loading4: true,
        loading5: true,
        searchValues: { area: data.areaProvince + '-' + data.id },
        currentCity: data.id,
      });
      this.getBoardOtherData(this.state.currentProduct, {
        area: data.areaProvince + '-' + data.id,
      });
    } else {
      this.setState({
        name: ['中国'],
        loading1: true,
        loading2: true,
        loading3: true,
        loading4: true,
        loading5: true,
        searchValues: null,
        currentCity: data.id,
      });
      this.getBoardOtherData(this.state.currentProduct, false, {
        areaProvince: data.areaProvince,
        areaCity: data.areaCity,
        areaDistrict: data.areaDistrict,
      });
    }
    let _this = this;

    this.intervalFn(option, _this);
    let indexs = 0;
    this.state.tagArr.forEach((item, index) => {
      if (item.id === data.id) {
        indexs = index;
      }
    });
    this.setState({
      tagArr: this.state.tagArr.slice(0, indexs + 1),
    });
  };
  render() {
    const chartHeight = parseInt(document.body.clientHeight - 160) / 2;
    const mapHeight = parseInt(document.body.clientHeight - 150);
    const canvasHeight = chartHeight - 45;
    const mapCanvasHeight = mapHeight - 45 - 48;
    const { loading1, loading2 } = this.state;
    const { loading3, loading4, loading5 } = this.state;
    // barData
    return (
      <Translation>
        {t => (
          <div className="dark-bg">
            <div className="dark-box">
              <div className="dark-title">
                {this.state.currentCity === '中国'
                  ? '全国'
                  : this.state.currentCity || '全国'}
                {this.state.title}大数据统计
                <div className="dark-time">
                  {this.state.currentTime}
                  <Button icon="poweroff" type="link" onClick={this.handleExit}>
                    退出
                  </Button>
                </div>
              </div>
              {/* <Row gutter={10} className="data-bars data-bars-dark">
                <Col span={6}>
                  <div className="data-bg data-bg1">
                    <div className="data-bar">
                      <p className="title">今日AI筛查数</p>
                      <p className="num">
                        <CountUp
                          className="gmv-show-gmv"
                          start={0}
                          end={barData.aiCnt || 0}
                          duration={1}
                        />
                      </p>
                    </div>
                  </div>
                </Col>
                <Col span={6}>
                  <div className="data-bg data-bg2">
                    <div className="data-bar">
                      <p className="title">今日AI筛查阳性新增</p>
                      <p className="num">
                        <CountUp
                          className="gmv-show-gmv"
                          start={0}
                          end={barData.aiPositiveCnt || 0}
                          duration={1}
                        />
                      </p>
                    </div>
                  </div>
                </Col>
                <Col span={6}>
                  <div className="data-bg data-bg3">
                    <div className="data-bar">
                      <div className="title">今日医生审核</div>
                      <p className="num">
                        <CountUp
                          className="gmv-show-gmv"
                          start={0}
                          end={barData.doctorCnt || 0}
                          duration={1}
                        />
                      </p>
                    </div>
                  </div>
                </Col>
                <Col span={6}>
                  <div className="data-bg data-bg4">
                    <div className="data-bar">
                      <div className="title">今日医生审核肺结核阳性新增</div>
                      <p className="num">
                        <CountUp
                          className="gmv-show-gmv"
                          start={0}
                          end={barData.doctorPositiveCnt || 0}
                          duration={1}
                        />
                      </p>
                    </div>
                  </div>
                </Col>
              </Row> */}
              <Row gutter={10} className="data-charts data-charts-dark">
                <Col span={6}>
                  <div
                    className="data-chart data-chart-dark"
                    style={{ height: chartHeight, marginBottom: '10px' }}
                  >
                    <span className="left-top"></span>
                    <span className="right-top"></span>
                    <span className="left-bottom"></span>
                    <span className="right-bottom"></span>
                    <div className="title">
                      <span className="name">阳性患者画像</span>
                      <Icon type="double-right" />
                      <span className="selected-date">最近30天</span>
                    </div>
                    <div
                      className="chart"
                      id="sexChart"
                      style={{ height: canvasHeight }}
                    ></div>
                    <div
                      className="dark-loading1"
                      style={{ display: loading1 ? '' : 'none' }}
                    >
                      <img src={loading} alt="" />
                    </div>
                  </div>
                  <div className="data-chart data-chart-dark">
                    <div
                      className="dark-loading1"
                      style={{ display: loading2 ? '' : 'none' }}
                    >
                      <img src={loading} alt="" />
                    </div>
                    <span className="left-top"></span>
                    <span className="right-top"></span>
                    <span className="left-bottom"></span>
                    <span className="right-bottom"></span>
                    <div className="title">
                      <span className="name">AI最近7日筛查人数</span>
                    </div>
                    <div
                      className="chart"
                      id="increaseChart"
                      style={{ height: canvasHeight }}
                    ></div>
                  </div>
                </Col>
                <Col span={12} style={{ height: mapHeight }}>
                  <div className="data-chart data-chart-dark">
                    <div
                      className="dark-loading2"
                      style={{ display: loading3 ? '' : 'none' }}
                    >
                      <img src={loading} alt="" />
                    </div>
                    <span className="left-top"></span>
                    <span className="right-top"></span>
                    <span className="left-bottom"></span>
                    <span className="right-bottom"></span>
                    <div className="title">
                      <span className="name">医疗机构业务分布</span>
                      <Icon type="double-right" />
                      <span className="selected-date">最近30天</span>
                    </div>
                    <div className="canvasTag">
                      {this.state.tagArr.map(items => {
                        return (
                          <div
                            key={items.id}
                            onClick={() => this.changeMap(items)}
                          >
                            <div>{items.id}</div>
                            <div>{items.textPY}</div>
                            <Icon type="right" />
                          </div>
                        );
                      })}
                    </div>
                    <div
                      className="chart"
                      id="mapChart"
                      style={{ height: mapCanvasHeight }}
                    ></div>
                  </div>
                </Col>

                <Col span={6}>
                  <div
                    className="data-chart data-chart-dark"
                    style={{ height: chartHeight, marginBottom: '10px' }}
                  >
                    <div
                      className="dark-loading1"
                      style={{ display: loading4 ? '' : 'none' }}
                    >
                      <img src={loading} alt="" />
                    </div>
                    <span className="left-top"></span>
                    <span className="right-top"></span>
                    <span className="left-bottom"></span>
                    <span className="right-bottom"></span>
                    <div className="title">
                      <span className="name">传片量TOP</span>
                      <Icon type="double-right" />
                      <span className="selected-date">最近30天</span>
                    </div>
                    <div
                      className="chart"
                      id="rankChart"
                      style={{ height: canvasHeight }}
                    ></div>
                  </div>
                  <div
                    className="data-chart data-chart-dark"
                    style={{ height: chartHeight }}
                  >
                    <div
                      className="dark-loading1"
                      style={{ display: loading5 ? '' : 'none' }}
                    >
                      <img src={loading} alt="" />
                    </div>
                    <span className="left-top"></span>
                    <span className="right-top"></span>
                    <span className="left-bottom"></span>
                    <span className="right-bottom"></span>
                    <div className="title">
                      <span className="name">AI筛查阳性数TOP</span>
                      <Icon type="double-right" />
                      <span className="selected-date">最近30天</span>
                    </div>
                    <div
                      className="chart"
                      id="yangRankChart"
                      style={{ height: canvasHeight }}
                    ></div>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

export default withRouter(Form.create()(DataDarkForm));
